import { Badge } from '@/components/ui/badge'

interface UserCountBadgeProps {
  count?: number
  className?: string
}

export const UserCountBadge: React.FC<UserCountBadgeProps> = ({ count = 0, className = '' }) => {
  const displayCount = Math.max(count, 1)
  const isSingular = displayCount === 1

  return (
    <Badge variant='outline' className={`text-xs border-red-500 text-red-500 ${className}`}>
      {displayCount} {isSingular ? 'User' : 'Users'}
    </Badge>
  )
}
